export const cities = [
  //1st priority
  {
    title: 'Берлин',
    tagline: 'Город, устремлённый в будущее',
    image: '/images/slider/cities/chunlea.jpg'

  },
  {
    title: 'Дюссельдорф',
    tagline: 'Самая длинная барная стойка в мире',
    image: '/images/slider/cities/felipe-di.jpg'

  },
  {
    title: 'Мюнхен',
    tagline: 'Пивная столица Европы',
    image: '/images/slider/cities/kevin-young.jpg'
  },
  {
    title: 'Родос',
    tagline: 'Не только пляжи, но и активные виды отдыха',
    image: '/images/slider/sea/pawel-nolbert.jpg'

  },
  {
    title: 'Аликанте',
    tagline: 'Само название Коста-Бланка — то есть «Белый Берег» — как бы намекает на белизну пляжей',
    image: '/images/slider/sea/amelie-eliard.jpg'
  },

  {
    title: 'Барселона',
    tagline: 'Культурная столица Европы',
    image: '/images/slider/sea/johannes-groll.jpg'
  },
  {
    title: 'Тенерифе',
    tagline: 'Чёрный вулканический песок',
    image: '/images/slider/sea/jordan-opel.jpg'

  },
  {
    title: 'Неаполь',
    tagline: 'Родина пиццы под сенью Везувия',
    image: '/images/slider/cities/louis-kang.jpg'

  },
  {
    title: 'Рим',
    tagline: 'Пуп западной цивилизации',
    image: '/images/slider/cities/marcelo-novais.jpg'

  },
  {
    title: 'Верона',
    image: '/images/slider/cities/matthew-foulds.jpg'

  },

  {
    title: 'Ларнака',
    tagline: 'Променад под финиковыми пальмами',
    image: '/images/slider/sea/joseph-barrientos.jpg'
  },
  {
    title: 'Анталья',
    tagline: 'Туристическое сердце Турции',
    image: '/images/slider/sea/josh-spires.jpg'
  },
  {
    title: 'Тиват',
    tagline: 'Головокружительные виды «самого южного фьорда Европы»',
    image: '/images/slider/cities/mohammad-alizade.jpg'

  },
  // 2nd priority
  {
    title: 'Пиза',
    tagline: 'Падающая башня и не только',
    image: '/images/slider/cities/sharona-sinke.jpg'
  },
  {
    title: 'Бургас',
    tagline: 'Старый Несебыр — самое романтическое место на всём болгарском побережье',
    image: '/images/slider/sea/justin-kauffman.jpg'

  },
  {
    title: 'Инсбрук',
    image: '/images/slider/cities/trae-gould.jpg'
  },
  {
    title: 'Зальцбург',
    image: '/images/slider/cities/van-william.jpg'
  },
  {
    title: 'Катания',
    tagline: 'Родина мафии, Архимеда и крупнейшего вулкана Европы',
    image: '/images/slider/cities/marcelo-novais.jpg'

  },
  {
    title: 'Турин',
    image: '/images/slider/cities/chunlea.jpg'
  },
  {
    title: 'Пловдив',
    image: '/images/slider/sea/martin-jernberg.jpg'
  },
  {
    title: 'Варна',
    tagline: 'Название «Золотые пески» довольно точно описывает то, что вы увидите, добравшись сюда',
    image: '/images/slider/cities/felipe-di.jpg'

  },
  {
    title: 'Пафос',
    tagline: 'Наиболее престижный курорт Кипра',
    image: '/images/slider/sea/noah-rosenfield.jpg'
  },
  {
    title: 'Пальма-де-Майорка',
    image: '/images/slider/sea/marit-gijsberts.jpg'
  }
]


// WEBPACK FOOTER //
// ./src/data/cities.js